<ebw-monorepo-sidebar-header [icon]="'cable'" [title]="'map.sidebar.checkin_analysis.title'" [isSvg]="false"
  [isOutline]="false">
  {{ 'map.sidebar.checkin_analysis.info_section' | translate }}
</ebw-monorepo-sidebar-header>
<div *ngIf="filtersForm">
  <form class="d-flex flex-column mt-3" [formGroup]="filtersForm">
    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>{{ 'map.sidebar.checkin_analysis.type' | translate }}</mat-label>
        <mat-select formControlName="type">
          <mat-option [value]="typeEnum.RC">RC</mat-option>
          <mat-option [value]="typeEnum.LINK">{{ 'map.sidebar.checkin_analysis.fw_link' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline" *ngIf="filtersForm.get('type').value === typeEnum.LINK">
        <mat-label> {{ 'map.sidebar.checkin_analysis.fw_link' | translate }}</mat-label>
        <input matInput formControlName="filter" [matAutocomplete]="inputAutoComplete" />
        <mat-autocomplete class="map-searchbar" #inputAutoComplete="matAutocomplete"
          (optionSelected)="onAutocompleteSelectionChanged($event)">
          <mat-option *ngFor="let option of autoCompletefilteredOptions" [value]="option" [disabled]="!option.desc">
            <span *ngIf="!option.desc" class="d-block center" [matTooltip]="'map.search.more_description' | translate"
              matTooltipPosition="right" matTooltipClass="info-button-tooltip">
              {{ 'map.search.more' | translate }}
            </span>

            <span *ngIf="option.desc" class="d-block" [matTooltip]="option.desc" matTooltipPosition="right"
              matTooltipClass="info-button-tooltip">{{ option.desc }}
            </span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline" *ngIf="filtersForm.get('type').value === typeEnum.RC">
        <mat-label>RC </mat-label>
        <input matInput formControlName="filter" />
      </mat-form-field>
    </div>
    
    <div class="form-group row">
      <div *ngIf="companiesList.length > 1; else autoSelectCompany" class="col mt-2">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>System</mat-label>
          <mat-select [(value)]="selectedCompany" (selectionChange)="onSelectCompany($event)">
            <mat-option selected>Seleziona</mat-option>
            <mat-option
            *ngFor="let company of companiesList; let i = index"
            [value]="company.id">
              {{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-template #autoSelectCompany>
        <div class="col mt-2">
          <mat-label class="me-2">{{'map.sidebar.checkin_analysis.company_name' | translate}}</mat-label>
          <mat-label><b>{{formCompany?.name}}</b></mat-label>
        </div>
      </ng-template>
    </div>

    <div class="form-group row">
      <mat-form-field class="col mt-2" appearance="outline">
        <mat-label>{{ 'map.sidebar.checkin_analysis.date_range.title' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker" formGroupName="date_range">
          <input matStartDate placeholder="Inizio" formControlName="start" />
          <input matEndDate placeholder="Fine" formControlName="end" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </form>
  <div class="d-flex justify-content-end gap-3 mt-2">
    <button mat-flat-button color="secondary" (click)="reset()" [disabled]="filtersForm.invalid">
      {{ 'common.reset' | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="search()" [disabled]="filtersForm.invalid" style="float: right">
      {{ 'common.search' | translate }}
    </button>
  </div>
</div>
